import PropTypes from "prop-types";

import LinksList from "@/components/Elements/LinksList";

import { OrganizationType } from "./Organization.type";

const OrganizationsLinksList = ({ organizations }) => {
  const links = organizations?.map(({ id, name }) => ({
    label: name,
    to: `/organizations/${id}`,
  }));

  return <LinksList links={links} />;
};

OrganizationsLinksList.propTypes = {
  organizations: PropTypes.arrayOf(OrganizationType),
};

export default OrganizationsLinksList;
